/** PR B — herramientas comerciales controladas (Centro SaaS BNT). */

export const COMMERCIAL_RESET_CONFIRM_PHRASE = "CONFIRMO REINICIO COMERCIAL";

export const TEST_BUYER_PURGE_CONFIRM_PHRASE = "BORRAR PRUEBA";

export const TEST_BUYER_PURGE_BLOCKED_MESSAGE =
  "No se puede borrar con herramienta simple. Use suspensión o herramienta especializada.";

export const FUTURE_USER_LIFECYCLE_NOTE =
  "Borrado completo de usuarios obsoletos (datos operativos, XML, FIEL/CSD) queda pendiente. " +
  "Opciones futuras: suspender acceso, marcar inactivo o borrado total con inventario previo y confirmación fuerte.";

export const COMMERCIAL_RESET_WARNING =
  "Esta acción solo afecta datos comerciales/licenciamiento. No toca SAT, XML, FIEL/CSD, CIEC, clientes fiscales ni datos operativos.";

export const COMMERCIAL_TOOLS_RESET_OPTION_LABELS = {
  reset_requests: "Solicitudes comerciales",
  reset_acceptances: "Aceptaciones legales",
  reset_organization_licenses: "Licencias web/comerciales emitidas",
  reset_registry: "Cartera / registro comercial",
  reset_buyer_catalog: "Comprador en catálogo",
  reset_organization: "Organización comercial de prueba",
  reset_system_config_license: "Licencia instalada en system_config",
  unlink_user_organization: "Vínculo usuario ↔ organización",
  reset_to_trial: "Volver comprador a periodo de prueba",
  delete_user: "Eliminar usuario de prueba (opcional, deshabilitado por defecto)",
};

export const CAPABILITY_LABELS = {
  visor_sat: "Visor Fiscal SAT",
  laboral_repse: "Laboral / REPSE",
  tramites_fiscales: "Trámites Fiscales",
  gestion_despacho: "Gestión Despacho",
};

export function parseCommercialToolsError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  if (typeof err?.message === "string") return err.message;
  return "No se pudo completar la operación comercial.";
}

export function commercialToolsSearchFromQuery(searchParams) {
  return {
    email: (searchParams.get("email") || "").trim(),
    rfc: (searchParams.get("rfc") || "").trim().toUpperCase(),
    installation_id: (searchParams.get("installation_id") || "").trim().toUpperCase(),
    owner_user_id: (searchParams.get("owner_user_id") || "").trim(),
  };
}

export function commercialToolsLinkQuery({ email, rfc, installation_id, owner_user_id } = {}) {
  const q = new URLSearchParams();
  if (email) q.set("email", email);
  if (rfc) q.set("rfc", rfc);
  if (installation_id) q.set("installation_id", installation_id);
  if (owner_user_id) q.set("owner_user_id", owner_user_id);
  const s = q.toString();
  return s ? `/platform/commercial-tools?${s}` : "/platform/commercial-tools";
}

export function defaultResetOptions() {
  return {
    reset_requests: true,
    reset_acceptances: true,
    reset_organization_licenses: true,
    reset_registry: true,
    reset_buyer_catalog: true,
    reset_organization: true,
    reset_system_config_license: true,
    unlink_user_organization: true,
    reset_to_trial: true,
    delete_user: false,
  };
}
